// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__2GIuc","input":"Input_input__mf4d7","label":"Input_label__1ogNm","error":"Input_error__21MUy"};